module.exports = __webpack_public_path__ + "img/red-3-diamond-striped.5392240d.svg";